import { Box, styled } from '@mui/material';
import { OnboardingStep } from 'further-types/lp/onboarding';
import { match } from 'ts-pattern';
import TaxDeclarationsDetails from './TaxDeclarationsDetails';
import InvestorClassificationDetails from './InvestorClassificationDetails';
import KycOrKybDetails from './KycOrKybDetails';
import { InvestorTaxDetails } from '../../../types';
import ErrorBoundary from 'components/ErrorBoundary';
import { Disclosure } from 'further-ui/hooks';

const Container = styled(Box)(({ theme }) => ({
  padding: theme.spacing(
    0,
    theme.spacingSizes.sm,
    theme.spacingSizes.sm,
    theme.spacingSizes.sm,
  ),
}));

type Props = {
  step: OnboardingStep;
  taxDetails: InvestorTaxDetails | null;
  vehicleId: string;
  vehicleApplicationId: string;
  investorId: string;
  manualKycDisclosure: Disclosure;
};

const ReviewedStepDetails: React.FC<Props> = ({
  step,
  taxDetails,
  vehicleId,
  vehicleApplicationId,
  investorId,
  manualKycDisclosure,
}) => {
  if (
    ![
      OnboardingStep.InvestorClassification,
      OnboardingStep.TaxDeclarations,
      OnboardingStep.KYCOrKYB,
    ].includes(step)
  ) {
    return null;
  }

  return (
    <Container>
      <ErrorBoundary>
        {match(step)
          .with(OnboardingStep.TaxDeclarations, () => (
            <TaxDeclarationsDetails taxDetails={taxDetails} />
          ))
          .with(OnboardingStep.InvestorClassification, () => (
            <InvestorClassificationDetails
              vehicleId={vehicleId}
              vehicleApplicationId={vehicleApplicationId}
              investorId={investorId}
            />
          ))
          .with(OnboardingStep.KYCOrKYB, () => (
            <KycOrKybDetails
              vehicleId={vehicleId}
              vehicleApplicationId={vehicleApplicationId}
              manualKycDisclosure={manualKycDisclosure}
            />
          ))
          .otherwise(() => null)}
      </ErrorBoundary>
    </Container>
  );
};

export default ReviewedStepDetails;
